/**
 * FinancialsTab Component
 *
 * Third tab of the Investment Editor with three sub-tabs:
 * 1. Summary - Overview of costs and benefits with ROI metrics
 * 2. Costs - Detailed cost breakdown with CapEx/OpEx
 * 3. Benefits - Type 1 (hard) and Type 2 (soft) benefits
 */

import { Tabs, TabList, TabItem, TabPanels, TabPanel } from '@medsuite/ui-components';
import React, { useState } from 'react';

import BenefitsSubTab from './financials/BenefitsSubTab';
import { CostsSubTab } from './financials/CostsSubTab';
import { SummarySubTab } from './financials/SummarySubTab';

import type { Investment } from '@medsuite/models';

interface FinancialsTabProps {
  investment: Investment;
  isEditing: boolean;
  setIsEditing: (editing: boolean) => void;
}

/**
 * FinancialsTab Component
 */
export const FinancialsTab: React.FC<FinancialsTabProps> = ({
  investment,
  isEditing,
  setIsEditing,
}) => {
  const [activeSubTab, setActiveSubTab] = useState(0);

  return (
    <div className="space-y-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
        <Tabs selectedIndex={activeSubTab} onChange={setActiveSubTab}>
          <TabList>
            <TabItem>Summary</TabItem>
            <TabItem>Costs</TabItem>
            <TabItem>Benefits</TabItem>
          </TabList>

          <TabPanels>
            {/* Sub-Tab 1: Summary */}
            <TabPanel>
              <SummarySubTab investment={investment} />
            </TabPanel>

            {/* Sub-Tab 2: Costs */}
            <TabPanel>
              <CostsSubTab
                investment={investment}
                isEditing={isEditing}
                setIsEditing={setIsEditing}
              />
            </TabPanel>

            {/* Sub-Tab 3: Benefits */}
            <TabPanel>
              <BenefitsSubTab
                investment={investment}
                isEditing={isEditing}
                setIsEditing={setIsEditing}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </div>
  );
};

export default FinancialsTab;
